import {combineReducers} from 'redux';

import general from './plan-assign-general/reducer';
import selectOrgs from './plan-assign-select-orgs/reducer';
import selectPlan from './plan-assign-select-plan/reducer';
import summary from './plan-assign-summary/reducer';

export default combineReducers({general, selectPlan, selectOrgs, summary});
